import React from 'react';
import { Table, Tag  } from 'antd';
import CustomAvatar from './customAvatar';
import { s3 } from '../utils';
import { navigate } from "@reach/router"
import { getCurrencySign } from '../utils/invoices';
import moment from 'moment';

const { orderBy } = require('lodash');

const renderOffer = (type) => {
  switch (type) {
    case 'client':
      return renderOfferForClient();
    case 'candidate':
      return renderOfferForCandidate();
    default:
      return null;
  }
}

const genericColumn = () => {
  return [
    {
      title: 'On Board',
      width: '10%',
      key: 'onBoardDate',
      render: (offer) => <>
        {moment(offer.onBoardDate).format('YYYY-MM-DD')}
      </>
    },
    {
      title: 'Location',
      width: '10%',
      dataIndex: 'location',
      key: 'location',
    },
    {
      title: 'Position',
      width: '10%',
      dataIndex: 'position',
      key: 'position',
    },
    {
      title: 'Service',
      width: '10%',
      dataIndex: 'service',
      key: 'service',
    },
    {
      title: 'Currency',
      width: '8%',
      dataIndex: 'currency',
      key: 'currency',
    },
    {
      title: 'Salary',
      width: '8%',
      render: (offer) => <div>
        <b><Tag color="#B0BF1A">{getCurrencySign(offer.currency)} {offer.salary.toLocaleString()}</Tag></b>
      </div>
    },
    {
      title: 'Sign On Bonus',
      width: '8%',
      dataIndex: 'signOnBonus',
      key: 'signOnBonus',
    },
    {
      title: 'Bonus',
      width: '10%',
      dataIndex: 'bonus',
      key: 'bonus',
    },
    {
      title: 'Relocation Allowance',
      width: '16%',
      dataIndex: 'relocationAllowance',
      key: 'relocationAllowance',
    },
  ]
}

const renderOfferForCandidate = () => {
  const client = {
    title: 'Client',
    width: '15%',
    key: 'client',
    render: (offer) => <div style={{cursor: "pointer"}} onClick={() => {
      navigate(`/clients/${offer.client.id}`)
    }}>
      <CustomAvatar
        colourCode={offer.client.name.charAt(0).toLowerCase()}
        char={`${offer.client.name.charAt(0).toUpperCase()}`}
        charSize={13}
        size={26}
        src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/client/${offer.client.id}.jpeg`}
      />
      &nbsp;{offer.client.name}
    </div>
  }

  return [
    ...[client],
    ...genericColumn(),
  ]
}

const renderOfferForClient = () => {

  const candidate = {
    title: 'Candidate',
    width: '15%',
    key: 'candidate',
    render: (offer) => <div style={{cursor: "pointer"}} onClick={() => {
      navigate(`/candidates/${offer.candidate.id}`)
    }}>
      <CustomAvatar
        colourCode={offer.candidate.firstname.charAt(0).toLowerCase()}
        char={`${offer.candidate.firstname.charAt(0).toUpperCase()}${offer.candidate.lastname.charAt(0).toUpperCase()}`}
        charSize={13}
        size={26}
        src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/candidate/${offer.candidate.id}.jpeg`}
      />
      &nbsp;{offer.candidate.firstname} {offer.candidate.lastname}
    </div>
  }

  return [
    ...[candidate],
    ...genericColumn(),
  ]
}

function OffersList({ offers, type }) {
  return (
    <Table
      pagination={false}
      columns={renderOffer(type)}
      dataSource={orderBy(offers, 'onBoardDate', 'desc')}
      rowKey="id"
      scroll={{ x: 1800 }}
    />
  );
}

export default OffersList;
